import { createActionGroup, emptyProps, props } from '@ngrx/store';

import type { RbacPermissionsEntity } from './rbac-permissions.model';

const RbacPermissionsActions = createActionGroup({
    source: 'RbacPermissions',
    events: {
        'Load Rbac Permissions Request': emptyProps(),
        'Load Rbac Permissions Success': props<{ permissions: RbacPermissionsEntity }>(),
        'Load Rbac Permissions Failure': props<{ error: string }>(),
    },
});

export default RbacPermissionsActions;
